export default {
    "cbg": "Chưa bàn giao MKT",
    "active": "Đang hoạt động",
    "locked": "Khóa",
}
